import React, { useState, useContext } from 'react'
import { TreeContext } from './Tree'
import intersection from 'lodash/intersection'
import { NoData } from './nodes/common'
import matchSorter from 'match-sorter'

const Node = props => {
	const getNodeLabel = (name) => {
		if(name) {
			return name
		}
		if(nodeData.__typename === 'Floor') {
			return `${nodeData.__typename} ${nodeData.number}`
		}
		//place for custom cases (for ex __typename === 'Floor')
			 // more usual case
		return `${nodeData.__typename} ${props.itemKey ? props.itemKey + 1 : ''}` || ' '
	}

	const { depth, searchStr = '', nodeData = {}, isLastChild, index } = props
	const {
		NodeComponent,
		handleSwitchNode,
		hideNoCRBranches,
		startConcealed,
		activeLeafs,
		selectedNode = {},
		handleSelect,
		isSelectable,
		isCheckable,
		showLeafCount,
		inverted,
		searchFunction
	} = useContext(TreeContext)
	const { leafIds } = nodeData
	const [showContent, setShowContent] = useState(!startConcealed)

	const idIntersection = intersection(leafIds, activeLeafs)
	const nodeStatus = leafIds.length && idIntersection.length === leafIds.length ? 'ACTIVE' : idIntersection.length ? 'PARTIAL_ACTIVE' : 'INACTIVE'
	const isSelected = selectedNode.id === nodeData.id && selectedNode.__typename === nodeData.__typename
	const isLeafNode = (nodeData.__typename === 'CashRegister') || (nodeData.__typename === 'Room')
	const checkOnSelect = (isSelectable === true || (isSelectable?.__typename === nodeData.__typename))

	const toggleShowContent = e => {
		e.stopPropagation()
		setShowContent(prevShowContent => !prevShowContent)
	}

	const onToggleSwitch = e => {
		handleSwitchNode(leafIds, e.target.checked)
	}

	const onSelect = e => {
		handleSelect(nodeData)
	}

	const nodeLabel = getNodeLabel(nodeData.name)

	const commonNodeProps = {
		index,
		inverted,
		isSelected,
		isSelectable,
		checkOnSelect,
		isCheckable,
		isLastChild,
		showLeafCount,
		nodeData,
		leafCount: leafIds.length,
		activeLeafCount: idIntersection.length,
		label: nodeLabel,
		status: nodeStatus,
		handleSelect: onSelect,
		toggleActive: onToggleSwitch,
		isOpened: showContent,
		toggleOpened: toggleShowContent
	}

	const handleSearch = node => {
		if(searchFunction) {
			return searchFunction(node)
		}
		const matchedNodes = matchSorter([node], searchStr, {
			keys: Object.keys(node).filter(key => key !== 'id' && key !== '__typename' && key !== 'mod_ver'),
			threshold: matchSorter.rankings.CONTAINS
		})
		return !!matchedNodes.length
	}

	let childrenNodes = null
	if(!isLeafNode) {
		childrenNodes = [...(nodeData.children || [])]
			.reduce((acc, node, i) => {
				const isSearchDirectMatch = searchStr ? handleSearch(node) : true
				const isSearchChildMatch = searchStr ? node.allChildren.some(handleSearch) : true
				if((isSearchDirectMatch || isSearchChildMatch) && (node.leafIds.length || !hideNoCRBranches)) {
					acc.push({ node, isSearchDirectMatch })
				}
				return acc
			}, [])
		if(!childrenNodes.length) {
			childrenNodes = <NoData {...commonNodeProps} isLeaf={nodeData.__typename === 'Shop'}/>
		} else {
			childrenNodes = childrenNodes
				.sort((a, b) => {
				  const nameA = a.node.name.toUpperCase()
				  const nameB = b.node.name.toUpperCase()
				  if (nameA < nameB) {
				  	return -1
				  }
				  if (nameA > nameB) {
				  	return 1
				  }
				  return 0
				})
				.map(({ node, isSearchDirectMatch }, i) => (
					<Node
						key={i}
						index={i}
						depth={depth + 1}
						nodeData={node}
						isLastChild={i === childrenNodes.length - 1}
						searchStr={isSearchDirectMatch ? '' : searchStr}
					/>
				))
		}
	}

	return(
		<NodeComponent {...commonNodeProps}>
			{childrenNodes}
		</NodeComponent>
	)
}

export default Node
